export default __webpack_public_path__ + "static/media/640_dummy2016-fotograf04-mobile-de.6d624453.png";